import { Outlet } from "react-router";
import { OrganisationFeatureFlags } from "shared";

import { ITab, Tabs } from "../../../../../common/Atoms/Tabs";
import { useGetSelectedOrganisation } from "../../../../hooks/useGetSelectedOrganisation";

/** Layout for the statement settings - each section is a routed sub-tab rendered into the outlet */
export function StatementRoot() {
  const currentOrg = useGetSelectedOrganisation();
  const showCustom = !!currentOrg?.featureFlags?.includes(OrganisationFeatureFlags.AI_STATEMENT_BUILDER)
    || !!currentOrg?.featureFlags?.includes(OrganisationFeatureFlags.AI_STATEMENT_BUILDER_PARTIAL);

  const tabs: ITab[] = [
    {
      name: `Common`,
      href: ``,
    },
    {
      name: `Standard`,
      href: `standard`,
    },
    showCustom
      ? {
        name: `Custom`,
        href: `custom`,
        new: true,
      }
      : {
        name: `Custom`,
        href: `custom`,
        disabled: true,
        badge: { text: `Coming soon`, color: `gray` },
      },
  ];

  return (
    <>
      <Tabs
        tabs={ tabs }
        small
      />

      <Outlet />
    </>
  );
}
